"use client"

import { ScreenShareOff } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ScreenShareOffIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ScreenShareOffIcon = component(Icon)({ as: ScreenShareOff })
